import { CbhFeatureFlag } from "../../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../../FeatureFlags/useCbhFlag";

export function useIsJobsRedirectionEnabled() {
  return useCbhFlag(CbhFeatureFlag.ENABLE_JOBS_MAP_VIEW_REDIRECTION, {
    defaultValue: false,
  });
}
